export default {
  fields: {
    discount: {
      label: 'Rabat',
    },
    usage_threshold: {
      label: 'Minimumsordrebeløb',
    },
    max_discount: {
      label: 'Maksimalt rabatbeløb',
    },
  },
};
